import { render, staticRenderFns } from "./AppearanceBlock.vue?vue&type=template&id=5ed2b8fc&"
import script from "./AppearanceBlock.vue?vue&type=script&lang=ts&"
export * from "./AppearanceBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports